import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import { delay } from '../../../Utility/Task/TaskQueue';
import { RenderSystemEvent } from '../../Render/RenderSystem';
import { PlaySound } from '../../Audio/AudioHelper';
import Container from '../../../Prototype/Container';
import {
    PlayAnimation,
    GetAnimationClip,
    StartAnimationClip,
} from '../AnimationHelper';
import TransformComponent from '../../../Component/Transform';
import { defaultCanvasSize } from '../../../Constants/Canvas';
import Game from '../../../Game';
import RewardTextEffect from '../../../Prototype/Effect/RewardTextEffect';
import CoinBar, { hackForceCurrencyAnimation } from '../../../Prefabs/UI/HUD/CoinBar';
import { RewardCoinsEffect } from './RewardCoinsEffect';
import { MainAnim } from './MainAnim';

interface IPlinkoRewardCoinsData {
    value: number;
    previousValue: number;
    target: CoinBar;
}

export class PlinkoRewardCoins extends AnimationClip<IPlinkoRewardCoinsData> {
    public *execute(
        animator: GameObject,
        meta: IPlinkoRewardCoinsData
    ): IterableIterator<number> {
        try {
            animator.scene.emit(RenderSystemEvent.BRING_TO_FRONT, animator);

            const text: GameObject = GameObject.findByName('coin_text')[0];

            const prevValueStr: string = meta.previousValue ? meta.previousValue.toFixed(0) : '0';
            (text.parent.parent as CoinBar).setCoinsText(prevValueStr);

            const coinsPanel: GameObject = meta.target;

            const rewardEffectContainer = GameObject.Instantiate(Container);
            const rewardTransform: TransformComponent = rewardEffectContainer.getComponent(
                TransformComponent
            );

            coinsPanel.addChild(rewardEffectContainer);
            animator.addChild(rewardEffectContainer);
            rewardTransform.x = defaultCanvasSize.x / 2;
            rewardTransform.y = defaultCanvasSize.y / 2;

            // Show coin bar
            yield* PlayAnimation(
                new MainAnim(
                    coinsPanel,
                    {
                        alpha: 1,
                        duration: 300,
                    }
                )
            );

            StartAnimationClip(
                new RewardCoinsEffect(rewardEffectContainer,
                    {
                        value: 3, // amount of coins
                        texture: 'coin-reward',
                        targetPosition: coinsPanel.container.position,
                    }
                )
            );

            const localeText = `+${Game.locale.getText('RewardCoins')}`;
            rewardEffectContainer.addChild(
                GameObject.Instantiate(RewardTextEffect, {
                    text: localeText.replace('[x]', meta.value.toString()),
                })
            );

            yield* delay(2000);
            rewardEffectContainer.destroy();

            PlaySound('coins-add');

            hackForceCurrencyAnimation();

            yield* PlayAnimation(
                GetAnimationClip('Counter', text.parent, {
                    startValue: meta.previousValue,
                    finalValue: meta.previousValue + meta.value,
                    onUpdateOverride: function () {
                        (text.parent.parent as CoinBar).setCoinsText(this.value.toFixed(0));
                    },
                })
            );

            // Hide coin bar
            yield* PlayAnimation(
                new MainAnim(
                    coinsPanel,
                    {
                        alpha: 0,
                        duration: 300,
                    }
                )
            );
        } catch (e) {
            console.warn('RewardCoins failed:', e);
        }
    }
}
